import { t } from "i18next";
import React from "react";
import { Trans } from "react-i18next";
import { useParams } from "react-router-dom";
import HorizontalButton from "../../../components/HorizontalButton";
import MobileViewLayout from "../../../layouts/MobileViewLayout";

const buttonText = [
  t("time_to_goal.options.five_min"),
  t("time_to_goal.options.ten_min"),
  t("time_to_goal.options.fifteen_min"),
  t("time_to_goal.options.twenty_min"),
];

const TimeSpending = () => {
  const params = useParams();
  return (
    <MobileViewLayout>
      <div className="d-flex align-items-center aitools-outer px-4">
        <div>
          <h2 className="fw-bold text-center  m-0 fs30 time-spending-header">
            <Trans i18nKey={"time_to_goal.question"} />
          </h2>
          <div className="w-100  d-flex flex-column gap-1 income-slab-option ">
            {buttonText.map((item, index) => (
              <HorizontalButton
                key={index}
                navigateTo={{
                  pathname: `/${params.gender}/personalPlan`,
                }}
                label={item}
                className="time-spending-button-text"
              />
            ))}
          </div>
        </div>
      </div>
    </MobileViewLayout>
  );
};

export default TimeSpending;
